import { render, staticRenderFns } from "./ReviewsCheckbox.vue?vue&type=template&id=1f98a7cc&scoped=true&"
import script from "./ReviewsCheckbox.vue?vue&type=script&lang=js&"
export * from "./ReviewsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCheckbox.vue?vue&type=style&index=0&id=1f98a7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98a7cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
